<template>
  <div class="list-body">
    <el-table border :data="orderList" style="width: 100%" class="list-table" tooltip-effect="dark">
      <el-table-column property="policyNo" min-width="160" label="保单号">
        <template slot-scope="{ row }">
          {{ row.policyNo | filterEmpty }}
        </template>
      </el-table-column>
      <el-table-column min-width="160" label="出单账户" key="mechanName" v-if="employee">
        <template slot-scope="{ row }">
          {{ row.mechanName | filterEmpty }}
        </template>
      </el-table-column>
      <el-table-column min-width="200" label="产品名称">
        <template slot-scope="{ row }">
          {{ row.productName | filterEmpty }}
        </template>
      </el-table-column>
      <el-table-column min-width="140" label="投/被保人">
        <template slot-scope="{ row }">
          <div>{{ row.policyerName }}<span v-if="row.policyerName && row.insuranceName">/</span>{{ row.insuranceName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="保单状态" min-width="100">
        <template slot-scope="{ row }">
          <div>{{ all.POLICY_STATUS[row.policyStatus] }}</div>
        </template>
      </el-table-column>
      <el-table-column label="应续日期-期数" min-width="150">
        <template slot-scope="{ row }">
          <div>{{ row.needPayTime | filterTime }}<span v-if="row.needPayTime && row.curRenewalTimes">-</span>{{ row.curRenewalTimes }}</div>
        </template>
      </el-table-column>
      <el-table-column label="交费方式" min-width="100">
        <template slot-scope="{ row }">
          <div>{{ row.payType | filterPayType }}</div>
        </template>
      </el-table-column>
      <el-table-column label="保费" min-width="120">
        <template slot-scope="{ row }">
          <div>{{ row.fee }}</div>
        </template>
      </el-table-column>
      <el-table-column label="预计服务费 (元)" min-width="120" key="incomes" v-if="checkAuth('orderCommission')">
        <template slot-scope="{ row }">
          <div>{{ row.incomes || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="续费状态" min-width="100">
        <template slot-scope="{ row }">
          <tooltip
            :txt-info="filterRenewal(row.renewalStatus) + '-' + row.renewalFailReason"
            v-if="(row.renewalStatus == 2 || row.renewalStatus >= 6) && row.renewalFailReason"
          ></tooltip>
          <tooltip :txt-info="filterRenewal(row.renewalStatus)" v-else></tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="{ row }">
          <el-button class="xq-btn" type="text" @click="goDetail(row.policyNo, row.newPolicyNo, '2', row.mechanName, row.mechanLevel)" plain>详情</el-button>
          <el-button class="xq-btn" type="text" @click="$refs.orderFollowRef.open(row)" plain>跟进备注</el-button>
        </template>
      </el-table-column>
      <emptyBox slot="empty"></emptyBox>
    </el-table>
    <!-- 跟进备注 -->
    <orderFollow ref="orderFollowRef" formType="long" @reload="$emit('reload')"></orderFollow>
  </div>
</template>

<script>
import orderFollow from './orderFollow';
import tooltip from '@/components/tooltip';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    orderFollow,
    tooltip,
  },
  props: {
    orderList: Array
  },
  data: () => ({
    all: {},
    employee: true
  }),
  created() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getUserInfo();
  },
  methods: {
    filterRenewal(val) {
      if (val == '2') {
        return '待续费';
      } else if (val == '5') {
        return '续费成功';
      } else if (val >= '6') {
        return '续费失败';
      }
    },
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      // 1一级团队 2二级团队 3员工
      if (data.level != 3 && data.level != 2) {
        this.userFlag = true;
      }
      if (data.level == 3) {
        this.employee = false;
      }
    },
    goDetail(policyNo, newPolicyNo, renewalType, mechanName, mechanLevel) {
      this.$router.push({
        path: '/order_xfd_detail',
        query: {
          policyNo: policyNo,
          newPolicyNo: newPolicyNo,
          renewalType: renewalType,
          mechanName: mechanName,
          mechanLevel: mechanLevel
        }
      });
    }
  },
  filters: {
    filterPayType(val) {
      if (!val) {
        return '-';
      } else if (val == 1) {
        return '年交';
      } else if (val == 2) {
        return '月交';
      } else if (val == 3) {
        return '季交';
      } else if (val == 4) {
        return '半年交';
      }
    },
    filterNull(val) {
      if (val == '' || val == null) {
        return '-';
      } else {
        return val;
      }
    },
    filterTime(time) {
      if (time) {
        time = time.split(' ')[0].replace(/-/g, '/');
        return time;
      }
      return time;
    }
  }
};
</script>

<style lang='scss' scoped>
@import './order_xfd_card';
</style>